import ROLES from "@/constant/roles";
export default {
    ROLES: ROLES
}
